// extracted by mini-css-extract-plugin
export var svgPathFill = "b8_jF";
export var svgPathFillEvenOdd = "b8_jJ";
export var svgPathFillNone = "b8_jK";
export var svgPathStroke = "b8_jG";
export var svgPathStrokeThree = "b8_jL";
export var svgPathStrokeWidthZero = "b8_jH";